import type { SyntheticEvent } from 'react'

import { useTranslation } from 'react-i18next'

import { CloseIcon, FacilityPill, chakra } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface SelectedFacilityPillIProps {
  colorScheme: ColorScheme
  label: string
  onRemove?: (event?: SyntheticEvent) => void
}

/** Facility/Label treatment for a selected MultiSelectInput item. */
export const SelectedFacilityPill = ({
  colorScheme,
  label,
  onRemove,
}: SelectedFacilityPillIProps) => {
  const { t } = useTranslation()

  return (
    <FacilityPill
      colorScheme={colorScheme}
      data-testid='selected-facility-pill'
      endAction={
        onRemove ? (
          <chakra.button
            aria-label={`${t('common:remove')} ${label}`}
            background='none'
            border='none'
            color='inherit'
            cursor='pointer'
            display='inline-flex'
            flexShrink={0}
            lineHeight={0}
            onClick={(event) => {
              event.stopPropagation()
              onRemove(event)
            }}
            p={0}
            type='button'
          >
            <CloseIcon color='currentColor' size={10} />
          </chakra.button>
        ) : undefined
      }
      gap='4px'
      px='8px'
      py='4px'
      textStyle='caption-medium'
    >
      {label}
    </FacilityPill>
  )
}
